import type { ComponentThemeStyles } from './types';

export const elegantTheme: ComponentThemeStyles = {
  typography: {
    headingFont: 'Playfair Display, Georgia, serif',
    bodyFont: 'Lora, Georgia, serif',
    baseSize: '16px',
  },
  navbar: {
    background: 'bg-white',
    text: 'text-gray-800',
    brandText: 'text-gray-900',
    linkText: 'text-gray-600',
    linkHover: 'hover:text-gray-900',
    border: 'border-b border-gray-100',
    shadow: '',
  },
  navigationMenu: {
    background: 'bg-white',
    text: 'text-gray-800',
    brandText: 'text-gray-900',
    linkText: 'text-gray-600',
    linkHover: 'hover:text-gray-900',
    border: 'border-b border-gray-100',
    shadow: '',
    dropdownBackground: 'bg-white',
    dropdownText: 'text-gray-700',
    dropdownHover: 'hover:bg-gray-50',
  },
  hero: {
    background: 'bg-gradient-to-br from-gray-900 to-gray-700',
    text: 'text-white',
    buttonStyle: 'bg-white text-gray-900 hover:bg-gray-100',
    pattern: false,
  },
  splitHero: {
    background: '#ffffff',
    text: '#1f2937',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    taglineColor: '#92400e',
    buttonBg: '#111827',
    buttonText: '#ffffff',
    buttonHover: '#374151',
  },
  htmlSplit: {
    background: '#ffffff',
    text: '#1f2937',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    taglineColor: '#92400e',
    buttonBg: '#111827',
    buttonText: '#ffffff',
    buttonHover: '#374151',
  },
  simpleHeader: {
    background: '#f8fafc',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
  },
  features: {
    background: 'bg-gray-50',
    cardBg: 'bg-white',
    iconColor: 'text-gold-600',
    titleColor: 'text-gray-900',
    textColor: 'text-gray-600',
    borderRadius: 'rounded',
  },
  footer: {
    background: 'bg-gray-900',
    text: 'text-gray-300',
    mutedText: 'text-gray-500',
    border: 'border-t border-gray-800',
  },
  cta: {
    background: 'bg-gray-900',
    text: 'text-white',
    buttonStyle: 'bg-white text-gray-900 hover:bg-gray-100',
  },
  form: {
    background: 'bg-white',
    inputBg: 'bg-gray-50',
    inputBorder: 'border-gray-200',
    inputText: 'text-gray-900',
    labelColor: 'text-gray-700',
    buttonStyle: 'bg-gray-900 text-white hover:bg-gray-800',
  },
  pricing: {
    background: 'bg-gray-50',
    cardBg: 'bg-white',
    highlightedCard: 'bg-gray-900 text-white',
    titleColor: 'text-gray-900',
    subtitleColor: 'text-gray-600',
    descriptionColor: 'text-gray-500',
    planTitle: 'text-gray-900',
    planDescription: 'text-gray-600',
    priceColor: 'text-gray-900',
    periodColor: 'text-gray-600',
    featureColor: 'text-gray-700',
    checkColor: '#6b7280',
    highlightedTitle: 'text-white',
    highlightText: '#6b7280',
    highlightedDescription: 'text-gray-300',
    highlightedPrice: 'text-white',
    highlightedPeriod: 'text-gray-300',
    highlightedFeature: 'text-gray-200',
    highlightedCheckColor: '#d4a373',
    borderColor: 'border-gray-200',
    highlightBorder: 'border-gray-700',
    highlightRing: 'ring-gray-700',
    hoverGlow: 'hover:shadow-gray-700/25',
    badgeBg: '#111827',
    badgeText: 'white',
    buttonBg: '#111827',
    highlightedButtonBg: '#ffffff',
  },
  mediaText: {
    background: '#f8fafc',
    titleColor: '#1e293b',
    textColor: '#475569',
    accentColor: '#111827',
  },
  faq: {
    background: '#faf5ff',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
    questionColor: '#1e293b',
    answerColor: '#475569',
    itemBackground: '#ffffff',
    itemBorder: '#e2e8f0',
    iconColor: '#111827',
  },
  testimonials: {
    background: '#f8fafc',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
    cardBackground: '#ffffff',
    cardBorder: '#e2e8f0',
    quoteColor: '#475569',
    nameColor: '#1e293b',
    roleColor: '#64748b',
    starColor: '#d4a373',
  },
  countdownTimer: {
    background: '#ffffff',
    text: '#1e293b',
    headline: '#1e293b',
    subheadline: '#64748b',
    number: '#d4a373',
    label: '#64748b',
  },
  imageGallery: {
    background: '#ffffff',
    text: '#1e293b',
    title: '#1e293b',
    subtitle: '#64748b',
    caption: '#475569',
    filterButton: '#f1f5f9',
    filterButtonActive: '#d4a373',
  },
  imageInfo: {
    background: '#ffffff',
    text: '#1e293b',
    title: '#1e293b',
    subtitle: '#64748b',
    imageBorder: '#d4a373',
    buttonBg: '#d4a373',
    buttonText: '#1e293b',
  },
  imageCard: {
    background: '#ffffff',
    overlayColor: '#1e293b',
    title: '#ffffff',
    description: '#e2e8f0',
    buttonBg: '#d4a373',
    buttonText: '#1e293b',
  },
  team: {
    background: '#ffffff',
    cardBg: '#f8fafc',
    nameColor: '#1e293b',
    roleColor: '#64748b',
    borderColor: '#e2e8f0',
  },
  video: {
    background: '#f8fafc',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
    textColor: '#475569',
  },
  textBlocks: {
    background: '#ffffff',
    titleColor: '#1e293b',
    textColor: '#475569',
    linkColor: '#d4a373',
  },
  titleSubtitle: {
    background: '#ffffff',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
    buttonBg: '#d4a373',
    buttonText: '#1e293b',
  },
  contactInfo: {
    background: '#f8fafc',
    titleColor: '#1e293b',
    textColor: '#475569',
    accentColor: '#d4a373',
  },
  headContent: {},
  bodyEnd: {},
  htmlEmbed: {
    background: '#ffffff',
  },
  promoBanner: {
    background: '#d4a373',
    text: '#1e293b',
    linkText: '#1e293b',
    dismissButton: '#1e293b',
  },
  logocloud: {
    background: '#faf8f5',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
  },
  stats: {
    background: '#faf8f5',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
    valueColor: '#b45309',
    labelColor: '#1e293b',
    descriptionColor: '#64748b',
  },
  blogPreview: {
    background: '#f8fafc',
    titleColor: '#1e293b',
    subtitleColor: '#64748b',
    cardBackground: '#ffffff',
    cardTitle: '#1e293b',
    cardExcerpt: '#475569',
    linkColor: '#b45309',
  },
  conversionPopup: {
    overlay: 'rgba(0,0,0,0.55)',
    panelBackground: '#ffffff',
    headlineColor: '#1e293b',
    bodyTextColor: '#475569',
    buttonBackground: '#b45309',
    buttonText: '#ffffff',
    closeButton: '#64748b',
  },
  blog: {
    pageBackground: '#f8fafc',
    headerBackground: '#ffffff',
    titleColor: '#1e293b',
    descriptionColor: '#475569',
    textColor: '#475569',
    mutedTextColor: '#64748b',
    linkColor: '#d4a373',
    linkHoverColor: '#b8956c',
    cardBackground: '#ffffff',
    cardBorder: '#e2e8f0',
    cardShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    cardHoverShadow: '0 4px 6px rgba(0, 0, 0, 0.07)',
    postTitleColor: '#1e293b',
    postTextColor: '#475569',
    postMetaColor: '#64748b',
    tagBackground: '#f1f5f9',
    tagText: '#475569',
    tagActiveBackground: '#1e293b',
    tagActiveText: '#ffffff',
    sidebarBackground: '#ffffff',
    sidebarTitleColor: '#1e293b',
    paginationBackground: '#ffffff',
    paginationText: '#475569',
    paginationBorder: '#e2e8f0',
    paginationActiveBackground: '#1e293b',
    paginationActiveText: '#ffffff',
    paginationDisabledOpacity: '0.5',
    iconColor: '#64748b',
    loadingSpinnerColor: '#d4a373',
    errorIconColor: '#94a3b8',
    errorButtonBackground: '#1e293b',
    errorButtonText: '#ffffff',
  },
};
